import React, {PropTypes} from 'react';
import {List, ListItem} from 'material-ui/List';
import IconCheckBox from '../../../Icons/IconCheckBox';
import IconCheckBoxChecked from '../../../Icons/IconCheckBoxChecked';
import shallowEqual from 'fbjs/lib/shallowEqual';
import debounce from 'lodash/debounce';

const notSelected = 'No selected countries';
const removeSelected = 'Remove all countries';
const allSelected = 'All countries is added';
const addAllNotSelected = 'Add all countries';

class CountryListItem extends React.PureComponent {
  static propTypes = {
    primaryText: PropTypes.string.isRequired,
    icon: PropTypes.node,
    code: PropTypes.string,
    onTouchTap: PropTypes.func.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return shallowEqual(this.props, nextProps);
  }

  _handleClick = debounce(() => {
    const {onTouchTap, code, disabled} = this.props;
    if (!disabled) onTouchTap(code);
  }, 100);

  render() {
    const {code, primaryText, icon, disabled} = this.props;
    return (<ListItem key={code}
              disabled={disabled}
              primaryText={primaryText}
              leftIcon={icon}
              onTouchTap={this._handleClick}/>);
  }
}

class ListCountries extends React.PureComponent {
  static propTypes = {
    countries: PropTypes.any,
    filter: PropTypes.bool,
    disabled: PropTypes.bool,
    onClickByItem: PropTypes.func,
    onDeleteAll: PropTypes.func,
    onAddAll: PropTypes.func
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  constructor() {
    super(...arguments);
    let {baseTheme: {palette: {accent1Color}}, textField} = this.context.muiTheme;

    this.style = {
      list: {
        width: '100%',
        maxHeight: '300px',
        overflow: 'auto',
        border: `solid 1px ${textField.borderColor}`,
        boxSizing: 'border-box'
      }
    };

    this.checkedIcon = (<IconCheckBoxChecked color={accent1Color}/>);
    this.uncheckedIcon = (<IconCheckBox color={accent1Color}/>);
  }

  render() {
    let {countries, filter, onDeleteAll, onAddAll, disabled, onClickByItem} = this.props;
    let {baseTheme: {palette: {accent1Color}}} = this.context.muiTheme;

    const styleActions = {
      textAlign: 'center',
      cursor: 'pointer',
      color: `${accent1Color}`,
      display: disabled ? 'none' : 'block'
    };

    return (
      <List style={this.style.list}>
        {
          countries.length > 0 && filter
            ? (
            <p style={styleActions}
               onClick={onDeleteAll}
            >{removeSelected}</p>
          ) : null
        }
        {
          countries.length > 0 && !filter
            ? (
            <p style={styleActions}
               onClick={onAddAll}
            >{addAllNotSelected}</p>
          ) : null
        }
        {
          countries.length > 0
            ? countries.map(({code, name}) => (
          <CountryListItem key={code}
                           code={code}
                           disabled={disabled}
                           primaryText={name}
                           icon={filter ? this.checkedIcon : this.uncheckedIcon}
                           onTouchTap={onClickByItem}/>

          ))
            : (<p style={{textAlign: 'center'}}> {filter ? notSelected : allSelected} </p>
          )

        }
        
      </List>
      
    );
  }

}

export default ListCountries;



// WEBPACK FOOTER //
// ./src/components/form/Countries/List/List.jsx